import type { LifetimeParameters } from '@hub/bearing-hub/common/types';
import { lifetimeConfigTypeOfOperation } from '@hub/bearing-hub/common/types';
import { BearingHubHelper } from '@hub/libs/bearing-hub.helper';
import { TemperatureCode } from '@icommerce/units';
import {
  IbhSpatialTypeOfMovements,
  IbhTechnicalEnvironment,
  IbhTemporalTypeOfMovement,
  IbhUnitSystem,
} from '@igus/iglidur-bearing-hub-api/src/data-contracts';

export const DefaultServiceLifeForBearings: LifetimeParameters = {
  oppositeMaterialId: '1',
  environment: IbhTechnicalEnvironment.Dry,
  load: {
    force: 20,
  },
  temperature: 23,
  acceptableWear: 0.25,
  activityMinutesPerHour: 60,
  typeOfMovement: IbhSpatialTypeOfMovements.Rotation,
  linearStrokeLength: 10,
  linearFrequency: 10,
  typeOfOperation: lifetimeConfigTypeOfOperation.continous,
  temporalLinearPart: 1,
  temporalTypeOfMovement: IbhTemporalTypeOfMovement.Simultaneous,
  rotationRevolutions: 10,
};

export const DefaultServiceLifeForBearingsForUS: LifetimeParameters = {
  ...DefaultServiceLifeForBearings,
  // this is a const value that user can not change
  temperature: 23,
  load: {
    force: 4.5,
  },
  acceptableWear: 0.00984,
};

export const getDefaultTemperatureServiceLife = (unitSystem: IbhUnitSystem): number => {
  return BearingHubHelper.convertTemperatureUnit(
    { value: DefaultServiceLifeForBearings.temperature, unit: TemperatureCode.CELSIUS },
    unitSystem === IbhUnitSystem.Metric ? TemperatureCode.CELSIUS : TemperatureCode.FAHRENHEIT
  );
};
